<div class="game-score__container" *transloco="let t; prefix: 'pages.game-component'">
    <app-nav-button *ngIf="themeService.isClosable()" icon="xmark-circle" (clickEvent)="onCloseClicked()" class="game-score__back-button" />
    <div class="game-score__content" *ngIf="gameInterfaceState !== GameInterfaceState.GameStarted">
        <div class="game-score__title">
            <span class="typography-text-x2-large-bold-primary">
                {{ gameName }}
            </span>
        </div>
    </div>
    <div class="game-score__content" *ngIf="gameInterfaceState === GameInterfaceState.GameStarted">
        <div class="game-score__title" *ngIf="formattedTournamentCountdown">
            <span class="typography-text-large-semibold-primary game-score__event-timer">
                {{ t('countdown-end-within') }}
            </span>
            <span class="typography-text-medium-semibold-primary game-score__event-countdown">
                {{ formattedTournamentCountdown }}
            </span>
        </div>
        <div class="game-score__title" [ngClass]="{ 'cursor': opponentId }">
            <div role="button" class="player-name-icon" tabindex="0" (keydown.enter)="onOpponentClicked()"
                (keydown.space)="onOpponentClicked()" (click)="onOpponentClicked()">
                <span class="typography-text-small-regular-secondary versus"> vs </span>
                <span class="typography-text-x-large-bold-primary" [ngClass]="{ 'opponent-nick': opponentId }">
                    {{ opponent }}
                </span>
                <app-icon *ngIf="opponentId" icon="account" colorCss="--content-tertiary" sizeCss="--icon-medium"
                    class="app-icon" />
            </div>
        </div>

        <div class="game-score__chip-content">
            <div class="chip typography-text-medium-regular-secondary">
                <span>{{ reward  || translocoService.translate('pages.game-component.practice') }}</span>
                <app-currency-icon *ngIf="currencyIcon && reward" [icon]="currencyIcon" sizeCss="--icon-medium"
                    class="currency-icon"></app-currency-icon>
                <app-bounty-pill class="bounty-amount" *ngIf="bountyAmount" size="small" [amount]="getBountyAmount()"/>
            </div>
            <div *ngIf="score" class="chip typography-text-medium-regular-secondary">
                {{ score }}
            </div>
            <div *ngIf="countdown" class="chip typography-text-medium-regular-secondary">
                <span *ngIf="isEnded()">{{ t('countdown-ended') }}</span>
                <span *ngIf="countdown" [ngClass]="{
                  'game-score__danger': countdown < 60,
                }">{{ countdown | timeFormat }}</span>
            </div>
        </div>
    </div>
</div>